

function pageSchedule() {

  /**
     * Remove https://, http:// or www
     * @param {string} url
     */
    function cleanUrl(url) {
      url = url = url.replace(/^http(s?):\/\//gi, '');
      return url.replace(/www./gi, '');
    }

//import Slider from "../slider";
let musicUrl = $("#music-tab").data("url");
let cultureUrl = $("#culture-tab").data("url");
// console.log("musicUrl " + musicUrl);

    // console.log("test");
    // $.getJSON("../wp-content/themes/sohoradio/week-info.json", function (json) {
    //   // console.log("test");
    //   console.log(json);
    // });
    $(".c-schedule__tabs li").on("click", function () {
      $(".c-schedule__content")
        .find("#" + $(this).attr("data-id"))
        .addClass("active")
        .siblings()
        .removeClass("active");
      $(this).addClass("active").siblings().removeClass("active");
    });

    var $musicTabs = $("#music-tabs");
    var $musicTimetable = $("#music-schedule");

    var $cultureTabs = $("#culture-tabs");
    var $cultureTimetable = $("#culture-schedule");

    var $months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    function returnTime(time) {
      var userDate = time;
      var from = userDate.split(" ");
      var getTime = from[1];
      var splitTime = getTime.split(":");
      var isTime = splitTime[0] + ":" + splitTime[1];

      return isTime;
    }

    function returnCurrentDate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    }

    // https : sohoradiomusic.doughunt.co.uk/api/week-info
    // $.getJSON("../wp-content/themes/sohoradio/week-info.json", function (json) {
    // var musicUrl = "http://sohoradiomusic.doughunt.co.uk/api/week-info?callback=?";
    $.getJSON(musicUrl, function (json) {
      /*jQuery.getJSON('http://sohoradiomusic.doughunt.co.uk/api/week-info', function (json) {*/
      // console.log(json);
      var tabs = [];
      var key = "AIRTIME_API_VERSION";
      var index = 0;

      delete json[key];

      $.each(json, function (i, item) {
        // console.log(i, item);
        if (index <= 6) {
          var day = [];
          if (typeof item[0] !== "undefined") {
            var getDate = item[0]["start_timestamp"].split(" ")[0];
            var getMonth = getDate.split("-")[1];
            // console.log(getDate);
            // console.log(getMonth);
            // console.log(getDate, ">=", returnCurrentDate());
            if (getDate >= returnCurrentDate()) {
              day.push(i);
              day.push(getDate);
              day.push(getMonth);

              var $timetable = $(
                '<div class="schedule-table ' +
                  (returnCurrentDate() === getDate ? "active" : "") +
                  '" id="weekly-' +
                  i +
                  '"></div>'
              );

              $.each(item, function (d, listing) {
                var $listing = $(
                  '<div class="schedule-row" id="' + i + "_" + d + '"></div>'
                );

                var $startTime = returnTime(listing["start_timestamp"]);
                var $endTime = returnTime(listing["end_timestamp"]);
                var $url = listing["url"];
                var $time = $(
                  '<div class="schedule-column schedule-time">'
                ).append($startTime + " - " + $endTime);
                var $more = $('<div class="schedule-column schedule-more">');
                var $name = $('<div class="schedule-column schedule-name">');
                var $link = false;

                if ($url) {
                  $link = $(
                    '<a href="https://' + cleanUrl($url) + '">' + listing["name"] + "</a>"
                  );
                  $link.clone().appendTo($name);
                  $link.text("See more").appendTo($more);
                } else {
                  $name.append(listing["name"]);
                }
                $time.appendTo($listing);
                $name.addClass("no-more").appendTo($listing);
                $more.appendTo($listing);
                $listing.appendTo($timetable);
              });

              tabs.push(day);
              // console.log("timetable", $timetable);
              $timetable.appendTo($musicTimetable);

              index++;
            }
          }
        }
      });

      $.each(tabs, function (i, tab) {
        // console.log(i, tab);
        var getDate = tab[1];
        var getMonth = $months[parseInt(tab[2].replace(/^0+/, "")) - 1];

        var date = $('<span class="schedule-tab-date"></span>').append(
          getDate.split("-")[2].replace(/^0+/, "")
        );
        var month = $('<span class="schedule-tab-month"></span>').append(
          getMonth
        );
        var day = $('<span class="schedule-tab-day"></span>').append(
          tab[0].replace("next", "").substring(0, 3)
        );

        var $tab = $(
          '<li class="schedule-tab ' +
            (returnCurrentDate() === getDate ? "active" : "") +
            '" data-id="weekly-' +
            tab[0] +
            '"></li>'
        );

        $tab.append(day);
        $tab.append(date);
        $tab.append(month);

        $tab.appendTo($musicTabs);

        $tab.on("click", function () {
          $musicTimetable
            .find("#" + $(this).attr("data-id"))
            .addClass("active")
            .siblings()
            .removeClass("active");
          $(this).addClass("active").siblings().removeClass("active");
        });
      });
    });

    // https :  sohoradioculture.doughunt.co.uk/api/week-info
    // $.getJSON("../wp-content/themes/sohoradio/week-info-culture.json", function (json) {
    // var cultureUrl = "http://sohoradioculture.doughunt.co.uk/api/week-info?callback=?";
    $.getJSON(cultureUrl, function (json) {
      var tabs = [];
      var key = "AIRTIME_API_VERSION";
      var index = 0;

      delete json[key];

      $.each(json, function (i, item) {
        // console.log(i, item);
        if (index <= 6) {
          var day = [];
          var getDate = item[0]["start_timestamp"].split(" ")[0];
          var getMonth = getDate.split("-")[1];
          // console.log(getDate, ">=", returnCurrentDate());
          if (getDate >= returnCurrentDate()) {
            day.push(i);
            day.push(getDate);
            day.push(getMonth);

            var $timetable = $(
              '<div class="schedule-table ' +
                (returnCurrentDate() === getDate ? "active" : "") +
                '" id="weekly-' +
                i +
                '"></div>'
            );

            $.each(item, function (d, listing) {
              var $listing = $(
                '<div class="schedule-row" id="' + i + "_" + d + '"></div>'
              );
              var $startTime = returnTime(listing["start_timestamp"]);
              var $endTime = returnTime(listing["end_timestamp"]);
              var $url = listing["url"];
              var $time = $(
                '<div class="schedule-column schedule-time">'
              ).append($startTime + " - " + $endTime);
              var $more = $('<div class="schedule-column schedule-more">');
              var $name = $('<div class="schedule-column schedule-name">');
              var $link = false;

              if ($url) {
                $link = $(
                  '<a href="https://' + cleanUrl($url) + '">' + listing["name"] + "</a>"
                );
                $link.clone().appendTo($name);
                $link.text("See more").appendTo($more);
              } else {
                $name.append(listing["name"]);
              }
              $time.appendTo($listing);
              $name.addClass("no-more").appendTo($listing);
              $more.appendTo($listing);
              $listing.appendTo($timetable);
            });

            tabs.push(day);

            $timetable.appendTo($cultureTimetable);

            index++;
          }
        }
      });

      $.each(tabs, function (i, tab) {
        // console.log(i, tab);
        var getDate = tab[1];
        var getMonth = $months[parseInt(tab[2].replace(/^0+/, "")) - 1];

        var date = $('<span class="schedule-tab-date"></span>').append(
          getDate.split("-")[2].replace(/^0+/, "")
        );
        var month = $('<span class="schedule-tab-month"></span>').append(
          getMonth
        );
        var day = $('<span class="schedule-tab-day"></span>').append(
          tab[0].replace("next", "").substring(0, 3)
        );

        var $tab = $(
          '<li class="schedule-tab ' +
            (returnCurrentDate() === getDate ? "active" : "") +
            '" data-id="weekly-' +
            tab[0] +
            '"></li>'
        );

        $tab.append(day);
        $tab.append(date);
        $tab.append(month);

        $tab.appendTo($cultureTabs);

        $tab.on("click", function () {
          $cultureTimetable
            .find("#" + $(this).attr("data-id"))
            .addClass("active")
            .siblings()
            .removeClass("active");
          $(this).addClass("active").siblings().removeClass("active");
        });
      });
    });
}

pageSchedule();

barba.hooks.enter((data, next) => {
  pageSchedule();
});
